import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresGuest: true, title: 'Login' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { requiresGuest: true, title: 'Register' }
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: () => import('@/views/Pricing.vue'),
    meta: { title: 'Pricing' }
  },
  {
    path: '/api-pricing',
    name: 'ApiPricing',
    component: () => import('@/views/ApiPricing.vue'),
    meta: { title: 'API Pricing' }
  },
  {
    path: '/api-keys',
    name: 'ApiKeys',
    component: () => import('@/views/ApiKeys.vue'),
    meta: { requiresAuth: true, title: 'API Keys' }
  },
  {
    path: '/auth/google/callback',
    name: 'GoogleCallback',
    component: () => import('@/views/GoogleCallback.vue'),
    meta: { title: 'Google Login' }
  },
  {
    // Public landing for QRs generated anonymously on the WordPress site.
    // The view handles auth itself (redirects to login if needed) and then
    // attaches the QR to the user's account.
    path: '/claim-qr',
    name: 'ClaimQR',
    component: () => import('@/views/ClaimQR.vue'),
    meta: { title: 'Save Your QR Code' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { requiresAuth: true, title: 'Dashboard' }
  },
  {
    path: '/qrcodes',
    name: 'QRCodes',
    component: () => import('@/views/QRCodes.vue'),
    meta: { requiresAuth: true, title: 'QR Codes' }
  },
  {
    path: '/qrcodes/create',
    name: 'CreateQRCode',
    component: () => import('@/views/CreateQRCode.vue'),
    meta: { requiresAuth: true, title: 'Create QR Code' }
  },
  {
    path: '/qrcodes/:id',
    name: 'QRCodeDetail',
    component: () => import('@/views/QRCodeDetail.vue'),
    meta: { requiresAuth: true, title: 'QR Code Detail' }
  },
  {
    path: '/folders',
    name: 'Folders',
    component: () => import('@/views/Folders.vue'),
    meta: { requiresAuth: true, title: 'Folders' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile.vue'),
    meta: { requiresAuth: true, title: 'Profile' }
  },
  {
    path: '/subscription',
    name: 'Subscription',
    component: () => import('@/views/Subscription.vue'),
    meta: { requiresAuth: true, title: 'Subscription' }
  },
  {
    path: '/payment/success',
    name: 'PaymentSuccess',
    component: () => import('@/views/PaymentSuccess.vue'),
    meta: { requiresAuth: true, title: 'Payment Success' }
  },
  {
    path: '/payment/canceled',
    name: 'PaymentCanceled',
    component: () => import('@/views/PaymentCanceled.vue'),
    meta: { requiresAuth: true, title: 'Payment Canceled' }
  },
  // Catch-all route for invalid/undefined paths - MUST be last
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    meta: { isNotFound: true, title: 'Not Found' },
    // Redirect will be handled by the navigation guard based on auth state
    component: () => import('@/views/Login.vue')
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  // Handle catch-all route (invalid paths like /xxx, /admin, etc.)
  if (to.meta.isNotFound) {
    if (authStore.isAuthenticated) {
      // User is logged in - redirect to dashboard
      next('/dashboard')
    } else {
      // User is not logged in - redirect to login
      next('/login')
    }
    return
  }
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresGuest && authStore.isAuthenticated) {
    next('/dashboard')
  } else {
    next()
  }
})


export default router
